import React from 'react';
import { Box, Typography, alpha } from '@mui/material';

const SectionHeader = ({ icon, title, description, theme }) => {
  return (
    <Box sx={{ mb: description ? 3 : 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        {icon && (
          <Box
            sx={{
              mr: 2,
              p: 1.5,
              borderRadius: '12px',
              bgcolor: alpha(theme.palette.primary.main, 0.1),
              color: theme.palette.primary.main,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {icon}
          </Box>
        )}
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            color: theme.palette.text.primary,
            fontSize: { xs: '1.25rem', sm: '1.5rem' }
          }}
        >
          {title}
        </Typography>
      </Box>
      {description && (
        <Typography
          variant="body1"
          sx={{
            color: theme.palette.text.secondary,
            ml: icon ? 7 : 0,
          }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default SectionHeader;